import React, { useEffect, useState } from "react";
import MainLayout from "../../components/common/layout/main/MainLayout";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import withAuth from "../../hocs/withAuth";
import withApp from "../../hocs/withApp";
import { reports } from "../../utils/report";
import ReportBase from "./components/ReportBase";

function ReportPage() {
  const { code } = useParams();
  const [report, setReport] = useState<any>();

  useEffect(() => {
    const rpt = reports[code as string];
    if (rpt) {
      setReport(rpt);
    }else {
      setReport(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return (
    <MainLayout>
      {report ? (
        <ReportBase report={report} />
      ) : (
        <Typography sx={{ textAlign: "center", fontSize: "20px" }}>
          Báo cáo đang phát triển
        </Typography>
      )}
    </MainLayout>
  );
}

export default withAuth(withApp(ReportPage));
